<template>
    <div class="text-center mb-2">
        <h4 class="m-0">Attacks</h4>
    </div>

    <div v-for="(ability) in resolvedAbilities" :key="ability.id">
    <div
        class="attack-card card bg-dark text-light mb-3"
    >
        <!-- Card header with attack name -->
        <div
            class="card-header d-flex justify-content-between align-items-center"
        >
            <strong class="mb-0">{{ ability.name }}</strong>
        </div>

        <!-- Card body with details -->
        <div class="card-body">
            <div class="row mb-1">
                <div class="col-sm-12">                    
                    {{ ability.description }}
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { Modal } from "bootstrap";
import { useRosterStore } from "../stores/index";

export default {
    name: "MonsterAbilities",
    props: {
        abilities: {
            type: Array,
            default: () => [],
        },
        theme: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedAbility: null,
            modalInstance: null,
            character: {},
        };
    },
    methods: {
        getAbilityImage(stat) {
            if (!stat || stat.toLowerCase() === "none") stat = "survivor";
            return require(`@/../public/img/${stat}${this.theme}.png`);
        },
        openModal(ability) {
            this.selectedAbility = ability;
            if (!this.modalInstance) {
                this.modalInstance = new Modal(this.$refs.abilityModal);
            }
            this.modalInstance.show();
        },
        closeModal() {
            this.selectedAbility = null;
            if (this.modalInstance) this.modalInstance.hide();
        },
    },
    computed: {
        resolvedAbilities() {
            const store = useRosterStore();
            return this.abilities
                .map((name) =>
                    store.bestiaryAbilities.find((a) => a.name === name)
                )
                .filter(Boolean); // removes null if not found
        },
    },
};
</script>

<style scoped>
.ability-display {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}

.ability-card {
    padding: 8px;
    /* margin-bottom: 6px; */
    cursor: pointer;
    transition: background 0.2s;
}
</style>

